// extracted by mini-css-extract-plugin
module.exports = {"container":"navigation-module--container--310Lh","link":"navigation-module--link--8kOuL"};